import React, { useState, useEffect, useRef, useCallback } from "react";

const pad = (num) => String(num).padStart(2, "0");
const timeToSeconds = ({ hour, minute, second }) =>
  parseInt(hour) * 3600 + parseInt(minute) * 60 + parseInt(second);

export const TimerComponent = ({
  label,
  onChange,
  minTime = null,
  endTime = null,
  value,
  disabled = false,
  checkEdit = false,
  className = "inpu-Invalid",
}) => {
  const [time, setTime] = useState({ hour: "00", minute: "00", second: "00" });
  const [showDropdown, setShowDropdown] = useState(false);
  const wrapperRef = useRef(null);

  const toggleDropdown = () => setShowDropdown((prev) => !prev);

  const handleOutsideClick = useCallback((e) => {
    if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
      setShowDropdown(false);
    }
  }, []);

  useEffect(() => {
    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [handleOutsideClick]);

  useEffect(() => {
    if (minTime && checkEdit === false) {
      const minSec = timeToSeconds(minTime) + 5;
      const hour = Math.floor(minSec / 3600);
      const minute = Math.floor((minSec % 3600) / 60);
      const second = minSec % 60;

      const newTime = {
        hour: pad(hour),
        minute: pad(minute),
        second: pad(second),
      };

      setTime(newTime);
      if (onChange) onChange(newTime);
    } else {
      if (endTime && checkEdit) {
        const minSec = timeToSeconds(endTime);
        const hour = Math.floor(minSec / 3600);
        const minute = Math.floor((minSec % 3600) / 60);
        const second = minSec % 60;

        const newTime = {
          hour: pad(hour),
          minute: pad(minute),
          second: pad(second),
        };

        setTime(newTime);
        if (onChange) onChange(newTime);
      }
    }
  }, [minTime]);

  const handleTimeChange = (type, value) => {
    const updatedTime = { ...time, [type]: value };
    setTime(updatedTime);
    if (onChange) onChange(updatedTime);
  };

  const isOptionDisabled = (type, value) => {
    if (!minTime) return false;

    const paddedValue = pad(value);
    const minHour = parseInt(minTime.hour);
    if (type === "hour" && parseInt(value) < minHour) {
      return true;
    }
    const testTime = {
      hour: type === "hour" ? paddedValue : time.hour,
      minute: type === "minute" ? paddedValue : time.minute,
      second: type === "second" ? paddedValue : time.second,
    };

    const totalSeconds = timeToSeconds(testTime);
    const minSeconds = timeToSeconds(minTime) + 5;

    return totalSeconds < minSeconds;
  };

  // 🔁 Sync internal time state with external value prop (on edit)
  useEffect(() => {
    if (value && typeof value === "object") {
      const formattedValue = {
        hour: pad(value.hour || "00"),
        minute: pad(value.minute || "00"),
        second: pad(value.second || "00"),
      };
      setTime(formattedValue);
    }
  }, [value]);

  const renderOptions = (limit, type) => {
    return Array.from({ length: limit }, (_, i) => {
      const value = pad(i);
      const disabled = isOptionDisabled(type, value);
      const isSelected = time[type] === value;

      return (
        <div
          key={value}
          className={`timedown-option ${isSelected ? "selected-option" : ""} ${
            disabled ? "disabled-option" : ""
          }`}
          onClick={() => !disabled && handleTimeChange(type, value)}
        >
          {value}
        </div>
      );
    });
  };

  return (
    <div
      className={`timer-container ${
        disabled ? "opacity-50 pointer-events-none" : ""
      }`}
      ref={wrapperRef}
    >
      <label className="timer-label">{label}</label>
      <div
        className={`timer-display ${className}`} // ✅ Use passed-in class
        onClick={toggleDropdown}
        tabIndex={disabled ? -1 : 0}
      >
        {pad(time.hour || 0)} hr : {pad(time.minute || 0)} m :{" "}
        {pad(time.second || 0)} s
      </div>

      {showDropdown && (
        <div className="dropdown-menu" tabIndex={1}>
          <div className="dropdown-container">
            <div className="dropdown-column">{renderOptions(6, "hour")}</div>
            <div className="dropdown-column">{renderOptions(60, "minute")}</div>
            <div className="dropdown-column">{renderOptions(60, "second")}</div>
          </div>

          <div className="dropdown-actions">
            <button
              className="save-dropdown-time"
              onClick={() => setShowDropdown(false)}
            >
              save
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
